// -- == //
// import TicketMenuManagementCreate from "./lib/create";
import EventsContributorsTable from './lib/table';
import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function EventsContributorsPage() {
  const { contributors, eventEnd, contributorAccept, contributorReject } = useTypedSelector((state) => state.Events);
  const { departments } = useTypedSelector((state) => state.Departments);

  return (
    <S.Container>
      <S.Head>
        <PageTitle title="Contributors List" />
        <S.Text>{contributors?.data?.eventInfo?.title}</S.Text>
      </S.Head>
      <Gap size="20px" />
      <EventsContributorsTable
        data={contributors.data as any}
        departments={departments.data}
        loading={contributors.loading}
      />

      <AppLoading
        loading={
          contributors.loading ||
          departments.loading ||
          eventEnd.loading ||
          contributorAccept.loading ||
          contributorReject.loading
        }
      />
    </S.Container>
  );
}
